import { AnyAction, isType } from 'typescript-fsa';
import { WebUsage, WebUsageSummary } from '../../../services/account';
import { sysadminSetWebUsage, sysadminSetWebUsageDetails } from './actions';

interface ServerWebUsageState {
    summary: WebUsageSummary[];
    details: WebUsage[];
}

const initialServerWebUsageState: ServerWebUsageState = {
    summary: [], 
    details: []
}

export interface WebUsageState {
    [server: string]: ServerWebUsageState;
}

const initialWebUsageState: WebUsageState = {};

export function webUsageReducer(state: WebUsageState = initialWebUsageState, action: AnyAction): WebUsageState {
    if (isType(action, sysadminSetWebUsage)) {
        const serverState = {...state[action.payload.server] || initialServerWebUsageState};
        serverState.summary = action.payload.usage;
        return { ...state, [action.payload.server]: serverState };
    } else if (isType(action, sysadminSetWebUsageDetails)) {
        const serverState = {...state[action.payload.server] || initialServerWebUsageState};
        serverState.details = action.payload.usage;
        return { ...state, [action.payload.server]: serverState };
    }
    return state;
}
